import css from 'styled-jsx/css'
import colors from 'theme/colors'
export default css`
  .footer-audio {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
  }

  .wrapper-tag-name {
    width: max-content;
    overflow: hidden;
    flex: 2;
    padding: 0.3rem 1rem;
    background-color: rgba(0, 0, 0, 0.9);
  }

  .current-time,
  .link-to-download {
    padding: 0 0.5rem;
    color: ${colors.leatherBlack};
  }

  .tag-name {
    color: red;
    border-bottom: 1px dashed rgba(255, 255, 255, 0.3);
    animation: moveTag 10s infinite linear;
    position: relative;
    color: ${colors.white};
    text-align: center;
  }

  @keyframes moveTag {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(-100%);
    }
  }

  @media screen and (max-width: 992px) {
    .wrapper-tag-name {
      width: 100%;
    }
    .hidde-download-in-mobile {
      display: none;
    }
  }
`
